"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var theme = require("./theme.scss");
var ui_1 = require("@vidazoo/ui");
var ProfileForm = /** @class */ (function (_super) {
    tslib_1.__extends(ProfileForm, _super);
    function ProfileForm(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.onChange = function (e) {
            var onChange = _this.props.onChange;
            onChange(e.target.name, e.target.value);
        };
        return _this;
    }
    ProfileForm.prototype.render = function () {
        var _a = this.props, onCancel = _a.onCancel, avatarUrl = _a.avatarUrl, firstName = _a.firstName, lastName = _a.lastName, email = _a.email, onUpdate = _a.onUpdate, phone = _a.phone, isVidazooOrganization = _a.isVidazooOrganization;
        return (React.createElement(ui_1.Form, { className: theme.profile, onSubmit: onUpdate },
            React.createElement("div", { className: theme.avatar },
                React.createElement(ui_1.Avatar, { large: true, imageUrl: avatarUrl }),
                React.createElement("div", { className: theme.link },
                    React.createElement("a", { href: "https://en.gravatar.com", target: "_blank" }, "Update image"))),
            React.createElement(ui_1.Label, { className: theme.label, spacing: 1.25, size: 13, weight: 600 }, "User Details"),
            React.createElement(ui_1.AggregateChangeComponent, { onChange: this.onChange },
                React.createElement("div", { className: theme.row },
                    React.createElement(ui_1.FormInput, { defaultValue: firstName, fill: true, name: "firstName", label: "First Name", required: true, autoComplete: "nope" }),
                    React.createElement(ui_1.FormInput, { defaultValue: lastName, fill: true, name: "lastName", label: "Last Name", required: true, autoComplete: "nope" }))),
            isVidazooOrganization ?
                React.createElement("div", { className: theme.row },
                    React.createElement(ui_1.FormPhoneNumberInput, { value: phone, fill: true, name: "phone", label: "Phone Number", onChange: this.onChange }))
                : null,
            React.createElement("div", { className: theme.row },
                React.createElement(ui_1.FormInput, { disabled: true, defaultValue: email, fill: true, name: "email", label: "Email", required: true, autoComplete: "nope", onChange: this.onChange })),
            React.createElement("div", { className: theme.options },
                React.createElement(ui_1.Button, { type: "button", medium: true, gray: true, onClick: onCancel }, "Cancel"),
                React.createElement(ui_1.Button, { type: "submit", medium: true, blue: true }, "Save Changes"))));
    };
    ProfileForm.defaultProps = {};
    return ProfileForm;
}(React.Component));
exports.default = ProfileForm;
